export const ClinicUnits = Object.freeze({
  HOSPITAL: 'hospital',
  TEAM: 'team',
});
